@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper [headerLabel]="modalTitle"
                  (save)="save()"
                  (cancel)="cancel()"
                  [hideSave]="displayMode === DisplayModeEnum.View"
                  [disableSave]="form && !form.valid">
    @if (form) {
        <form class="factor-table-details d-flex flex-column" [formGroup]="form">
            <div class="view-toggle d-flex">
                <div class="align-items-center justify-content-center"
                     [class.selected]="selectedView === PanelView.Details"
                     (click)="setViewSelection(PanelView.Details)">
                    TABLE INFO
                </div>
                <div class="align-items-center justify-content-center"
                     [class.selected]="selectedView === PanelView.List"
                     (click)="setViewSelection(PanelView.List)">
                    FACTORS
                </div>
            </div>
            <div [class.active]="selectedView === PanelView.Details" class="factor-table-panel">
                <div class="details-panel">
                    <div class="row" formGroupName="coreGroup">
                        <div class="col-lg-6">
                            <div class="mb-3"
                                 [ngClass]="{ 'has-error': fCore.controls.tableName.touched && fCore.controls.tableName.errors }">
                                <label for="name">Table Name</label>
                                @if (displayMode === DisplayModeEnum.View) {
                                    <div>{{ fCore.controls.tableName.value }}</div>
                                }
                                @if (displayMode !== DisplayModeEnum.View) {
                                    <input type="text"
                                           class="form-control"
                                           formControlName="tableName"
                                           autocomplete="off"/>
                                }
                                @if (fCore.controls.tableName.touched && fCore.controls.tableName.errors) {
                                    <div class="error-feedback">
                                        @if (fCore.controls.tableName.errors.required) {
                                            <div class="text-danger small">Table name is required.</div>
                                        }
                                        @if (fCore.controls.tableName.errors.maxlength) {
                                            <div class="text-danger small">Table name is too long.</div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="mb-3"
                                 [ngClass]="{ 'has-error': fCore.controls.tableLife.touched && fCore.controls.tableLife.errors }">
                                <label for="life">Life</label>
                                @if (displayMode === DisplayModeEnum.View) {
                                    <div>{{ fCore.controls.tableLife.value }}</div>
                                }
                                @if (displayMode !== DisplayModeEnum.View) {
                                    <input type="number" class="form-control" formControlName="tableLife"/>
                                }
                                @if (fCore.controls.tableLife.touched && fCore.controls.tableLife.errors) {
                                    <div class="error-feedback">
                                        @if (fCore.controls.tableLife.errors.required) {
                                            <div class="text-danger small">Life is required.</div>
                                        }
                                    </div>
                                }
                            </div>
                            @if (displayMode === DisplayModeEnum.Add || displayMode === DisplayModeEnum.CopyFrom) {
                                <div class="mb-3"
                                     [ngClass]="{ 'has-error': fCore.controls.tableType.touched && fCore.controls.tableType.errors }">
                                    <label class="filter-label">Table Type</label>
                                    <div>
                                        @for (factorTableType of factorTableTypes; track factorTableType) {
                                            <label class="radio-inline">
                                                <input type="radio"
                                                       formControlName="tableType"
                                                       [value]="factorTableType.value"/>{{ factorTableType.name }}
                                            </label>
                                        }
                                        @if (fCore.controls.tableType.touched && fCore.controls.tableType.errors) {
                                            <div class="error-feedback">
                                                @if (fCore.controls.tableType.errors.required) {
                                                    <div class="text-danger small">Table type is required.</div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            @if (displayMode === DisplayModeEnum.View || displayMode === DisplayModeEnum.Edit) {
                                <div class="mb-3">
                                    <label class="filter-label">Table Type</label>
                                    <div>{{ factorTableTypeName }}</div>
                                </div>
                            }
                        </div>
                        <div class="col-lg-6">
                            <div class="mb-3"
                                 formGroupName="stateGroup"
                                 [ngClass]="{ 'has-error': fCoreState.controls.stateName.touched && fCoreState.controls.stateName.errors }">
                                <label for="state">State</label>
                                @if (displayMode === DisplayModeEnum.View) {
                                    <div>{{ fCoreState.controls.stateName.value }}</div>
                                }
                                @if (displayMode !== DisplayModeEnum.View) {
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="stateName"
                                        autocomplete="on"
                                        [wsTypeahead]="states"
                                        typeaheadOptionField="fullName"
                                        [typeaheadOptionsLimit]="50"/>
                                }
                                @if (fCoreState.controls.stateName.touched && fCoreState.controls.stateName.errors) {
                                    <div class="error-feedback">
                                        @if (fCoreState.controls.stateName.errors.required) {
                                            <div class="text-danger small">State is required.</div>
                                        }
                                    </div>
                                }
                            </div>
                            @if (source === GridSourceOptionEnum.Company) {
                                <div class="mb-3"
                                     formGroupName="companyGroup"
                                     [ngClass]="{ 'has-error': fCoreCompany.controls.companyName.touched && fCoreCompany.controls.companyName.errors }">
                                    <label for="company">Company</label>
                                    @if (displayMode === DisplayModeEnum.View) {
                                        <div>{{ fCoreCompany.controls.companyName.value }}</div>
                                    }
                                    @if (displayMode !== DisplayModeEnum.View) {
                                        <div class="ws-flex-auto input-group">
                                            <input type="text"
                                                   class="form-control"
                                                   autocomplete="off"
                                                   placeholder="Filter Companies..."
                                                   [typeaheadWaitMs]="750"
                                                   formControlName="companyName"
                                                   [wsTypeahead]="companiesDataSource$"
                                                   typeaheadOptionField="companyName"
                                                   [typeaheadOptionsLimit]="50"
                                                   [typeaheadMinLength]="1"
                                                   [typeaheadScrollable]="true"
                                                   (typeaheadOnSelect)="onCompanySelected($event)"
                                                   (typeaheadLoading)="onCompanyLoadingChange($event)"
                                                   (blur)="onCompanyBlur()"/>
                                            @if (companyEditing || !canEditCompany) {
                                                <span class="input-group-text"
                                                      [style.visibility]="companiesLoading ? 'visible' : 'hidden'">
                                                    <ws-ace-loader [inline]="true"></ws-ace-loader>
                                                </span>
                                            }
                                            @if (canEditCompany && !companyEditing) {
                                                <button class="ace-btn btn-secondary has-icon"
                                                        title="Edit company"
                                                        (click)="editCompany()">
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                            }
                                            @if (companyEditing) {
                                                <button class="ace-btn btn-secondary has-icon"
                                                        title="Save company"
                                                        (click)="saveCompany()"
                                                        [disabled]="!selectedCompanyId.getRawValue()">
                                                    <i class="fa fa-save"></i>
                                                </button>
                                            }
                                        </div>
                                    }
                                    @if (fCoreCompany.controls.companyName.touched && fCoreCompany.controls.companyName.errors) {
                                        <div class="error-feedback">
                                            @if (fCoreCompany.controls.companyName.errors.required) {
                                                <div class="text-danger small">Company is required.</div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <div class="mb-3" formGroupName="assessorGroup">
                                <label for="assessor">Assessor</label>
                                @if (displayMode === DisplayModeEnum.View) {
                                    <div>{{ fCoreAssessor.controls.assessorName.value || 'None' }}</div>
                                }
                                @if (displayMode !== DisplayModeEnum.View) {
                                    <div class="input-group">
                                        <input type="text"
                                               class="form-control"
                                               autocomplete="off"
                                               formControlName="assessorName"
                                               placeholder="Filter Assessors..."
                                               [wsTypeahead]="assessors"
                                               typeaheadOptionField="name"
                                               [typeaheadOptionsLimit]="100"
                                               [typeaheadMinLength]="0"
                                               [typeaheadScrollable]="true"
                                               (typeaheadOnSelect)="onAssessorSelected($event)"
                                               (blur)="onAssessorBlur()"/>
                                        <button class="ace-btn btn-secondary"
                                                title="Clear assessor"
                                                (click)="onAssessorClear()"
                                                [disabled]="!clearAssessorEnabled">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                }
                            </div>
                            <div class="mb-3">
                                <label for="retiredTaxYear">Retired Tax Year</label>
                                @if (displayMode === DisplayModeEnum.View) {
                                    <div>{{ fCore.controls.tableRetiredTaxYear.value }}</div>
                                }
                                @if (displayMode !== DisplayModeEnum.View) {
                                    <ws-select
                                        formControlName="tableRetiredTaxYear"
                                        [options]="taxYears"
                                        [isPrimitive]="true"
                                        [canDeselect]="true"
                                        deselectLabel="">
                                    </ws-select>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div [class.active]="selectedView === PanelView.List" class="factor-table-panel">
                <div class="ws-section ws-flex-none">
                    <div class="ws-section__header">
                        <h5 class="ws-section__header__title">Factors</h5>
                        @if (displayMode !== 2) {
                            <div class="ws-section__header__actions">
                                <div class="ws-section__header__actions__item">
                                    <span class="anchor-style" (click)="addAge()">Add Age</span>
                                </div>
                                <div class="ws-section__header__actions__item">
                                    <span class="anchor-style" (click)="addYear()">Add Year</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="table-responsive factors-grid">
                    <table class="table table-condensed factor-edit-table">
                        <thead>
                            <tr formArrayName="years">
                                <th></th>
                                @for (yearControl of fYears.controls; track yearControl; let yearIndex = $index) {
                                    <th>
                                        @if (displayMode === DisplayModeEnum.View) {
                                            <div>{{ yearControl.value }}</div>
                                        }
                                        @if (displayMode !== DisplayModeEnum.View) {
                                            <div class="input-group"
                                                 [ngClass]="{ 'has-error': yearControl.touched && yearControl.errors && yearControl.errors.required }">
                                                <input type="number"
                                                       class="form-control"
                                                       placeholder="Enter tax year..."
                                                       [formControlName]="yearIndex"
                                                       [attr.tabindex]="100 + (yearIndex * fAges.length) + yearIndex + 1"/>
                                                <span class="input-group-text clickable">
                                                    <i class="fa fa-trash fa-2x"
                                                       title="Remove tax year"
                                                       (click)="removeYear(yearIndex)"></i>
                                                </span>
                                            </div>
                                        }
                                    </th>
                                }
                            </tr>
                        </thead>
                        <tbody formArrayName="ages">
                            @for (ageGroup of fAges.controls; track ageGroup; let ageIndex = $index; let last = $last) {
                                <tr [formGroup]="$any(ageGroup)" [class.last-row]="last">
                                    <td>
                                        <div class="age-header d-flex justify-content-between align-items-center">
                                            <span>Age {{ ageIndex + 1 }}</span>
                                            @if (displayMode !== DisplayModeEnum.View) {
                                                <i class="fa fa-trash clickable" (click)="removeAge(ageIndex)"></i>
                                            }
                                        </div>
                                    </td>
                                    @for (
                                        factorControl of $any(ageGroup).controls.factors.controls; track factorControl; let
                                        yearIndex = $index) {
                                        <td formArrayName="factors">
                                            @if (displayMode === DisplayModeEnum.View) {
                                                <div>{{ factorControl.value }}@if (fCore.controls.tableType.value === 0) {
                                                    <span>%</span>
                                                }</div>
                                            }
                                            @if (displayMode !== DisplayModeEnum.View) {
                                                <div>
                                                    <div class="input-group factor-input-group">
                                                        <input type="number"
                                                               class="form-control"
                                                               [formControlName]="yearIndex"
                                                               [attr.tabindex]="100 + (yearIndex * fAges.length) + yearIndex + (ageIndex + 1)"/>
                                                        @if (fCore.controls.tableType.value === 0) {
                                                            <span class="input-group-text">%</span>
                                                        }
                                                    </div>
                                                    @if (factorControl.dirty && factorControl.errors) {
                                                        <div class="error-feedback" style="text-align: right">
                                                            @if (factorControl.errors.min) {
                                                                <div class="text-danger small">Must be grater than 0.
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                        @if (fFloors.controls[0]) {
                            <tbody>
                                <tr class="floor-row"><td class="ps-0 pb-2 pt-3" colspan="100%"><h5 class="floor-label">Floor Values</h5></td></tr>
                                <tr [formGroup]="$any(fFloors.controls[0])" class="last-row">
                                    <td></td>
                                    @for (
                                        floorControl of $any(fFloors.controls[0]).controls.floors.controls; track floorControl; let
                                        yearIndex = $index) {
                                        <td formArrayName="floors">
                                            @if (displayMode === DisplayModeEnum.View) {
                                                <div>@if (fCore.controls.tableType.value === 0) {
                                                    <span>$</span>
                                                }{{ floorControl.value }}
                                                </div>
                                            }
                                            @if (displayMode !== DisplayModeEnum.View) {
                                                <div>
                                                    <div class="input-group factor-input-group">
                                                        <span class="input-group-text">$</span>
                                                        <input type="text"
                                                               class="form-control ws-text-align-right"
                                                               [formControlName]="yearIndex"
                                                               [attr.tabindex]="100 + (yearIndex * fAges.length) + yearIndex + (fAges.length + 1)"/>
                                                    </div>
                                                    @if (floorControl.dirty && floorControl.errors) {
                                                        <div class="error-feedback" style="text-align: right">
                                                            @if (floorControl.errors.min) {
                                                                <div class="text-danger small">Must be grater than
                                                                    0.
                                                                </div>
                                                            }
                                                            @if (floorControl.errors.max) {
                                                                <div class="text-danger small">Value is too big.
                                                                </div>
                                                            }
                                                            @if (floorControl.errors.pattern) {
                                                                <div class="text-danger small">Invalid value.</div>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </td>
                                    }
                                </tr>
                            </tbody>
                        }
                    </table>
                </div>
                <!-- error feedback for the factor table grid -->
                <div class="error-feedback">
                    @if (fYearsHaveValidationErrorsRequired) {
                        <div class="text-danger small">Tax years are required and cannot be left empty.</div>
                    }
                    @if (fYearsHaveValidationErrorsUnique) {
                        <div class="text-danger small">Tax year values must be unique and cannot be duplicated.</div>
                    }
                </div>
            </div>
        </form>
    }
</ws-modal-wrapper>
